import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import MainLayout from "../../layouts/MainLayout";
import { API_URL, STORAGE_URL } from "../../utils/constants";
import { useEffect, useState } from "react";
import { Col, Row, Modal, ModalBody } from "reactstrap";
import { FiClock, FiShare2 } from "react-icons/fi";
import { PRIMARY } from "../../utils/colors";
import { FaEye, FaPhoneAlt } from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";
import DefaultButton from "../../components/Buttons/Default";
import DeletePropertyModal from "../../components/Modals/DeleteProperty";
import { generateKey, getOfficeName, nl2br, printPrice, tField } from "../../utils/helpers";
import { MdDownloading } from "react-icons/md";
import { IoHeartOutline, IoHeartSharp, IoClose } from "react-icons/io5";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import moment from "moment";
import './styles.css';
import BoostPropertyModal from "../../components/Modals/BoostProperty";
import { RiVerifiedBadgeFill } from "react-icons/ri";

function PropertyPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { id } = useParams();
  const [propertyLoading, setPropertyLoading] = useState(true);
  const [property, setProperty] = useState(location.state?.property || null);
  const [deleteModalShown, setDeleteModalShown] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [pauseLoading, setPauseLoading] = useState(false);
  const [imageViewerOpen, setImageViewerOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [allMedia, setAllMedia] = useState([]);
  const [boostModalShown, setBoostModalShown] = useState(false);

  useEffect(() => {
    if (!property) {
      getProperty();
    } else {
      if(property.images.length > 0) {
        setSelectedImage(STORAGE_URL + property.images[0].image_path);
      } else if(property.videos.length > 0) {
        setSelectedImage(STORAGE_URL + property.videos[0].video_path);
      }
      setPropertyLoading(false);
      addView();
    }
  }, [id]);

  useEffect(() => {
    if (property) {
      // Combine videos and images into one array
      const media = [
        ...(property.videos || []).map(v => ({
          type: 'video',
          path: STORAGE_URL + v.video_path
        })),
        ...(property.images || []).map(img => ({
          type: 'image',
          path: STORAGE_URL + img.image_path
        }))
      ];
      setAllMedia(media);
    }
  }, [property]);
  
  const getProperty = () => {    
    fetch(API_URL+'/properties/property/'+id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then(response => response.json())
    .then(data => {      
      if (data.success) {
        setProperty(data.property);
        if(data.property.images.length > 0) {
          setSelectedImage(STORAGE_URL + data.property.images[0].image_path);
        } else if(data.property.videos.length > 0) {
          setSelectedImage(STORAGE_URL + data.property.videos[0].video_path);
        }
      }
      setPropertyLoading(false);
    })
  }

  const addView = () => {
    fetch(API_URL+'/properties/property/'+id+'/add-view', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
  }

  const openImageViewer = (mediaPath) => {
    const index = allMedia.findIndex(m => m.path === mediaPath);
    setCurrentImageIndex(index);
    setImageViewerOpen(true);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % allMedia.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + allMedia.length) % allMedia.length);
  };

  const pause = (status) => {
    setPauseLoading(true);
    fetch(API_URL+'/user/properties/'+status+'/'+property.id, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then(response => response.json())
    .then(data => {
      if(data.success) {
        if(status === 'activate')
          toast.success('تم تفعيل الإعلان بنجاح');
        else if(status === 'pause')
          toast.success('تم ايقاف الإعلان بنجاح');

        getProperty();
      }
    })
    .catch(error => {
      console.error('Error:', error);
    })
    .finally(() => {
      setPauseLoading(false);
    });
  }

  const addToFavorites = () => {
    fetch(API_URL+'/user/favorites/store', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        property_id: property.id
      })
    })
    .then(response => response.json())
    .then(data => {
      if(data.success === true) {
        setProperty(data.property)
      } else {

      }
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }

  const share = ()  => {
    if (navigator.share) {
      navigator.share({
        title: property?.title,
        text: 'قم بزيارة هذا العقار على موقع مشنص',
        url: 'https://mishnis.net/ar/property/' + property?.id
      })
      .then(() => console.log('Share successful'))
      .catch(error => console.error('Error sharing:', error));
    } else {
      alert('المشاركة غير متاحة على هذا المتصفح');
    }
  }

  const incrementCallsCount = () => {
    fetch(API_URL+'/properties/property/'+property.id+'/increment-calls-count', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
  }

  const incrementWhatsappCount = () => {
    fetch(API_URL+'/properties/property/'+property.id+'/increment-whatsapp-clicks-count', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
  }

  const generateWhatsappMessage = () => {
    let message = "مرحبًا، أنا مهتم بهذا الإعلان:\n\n";
    message += `العنوان: ${property?.title_ar}\n`;
    if (property?.price) {
      message += `السعر: ${printPrice(property.price)} د.ك \n\n`;
    } else {
      message += "\n";
    }
    message += `https://mishnis.net/ar/property/${property?.id}`;
    return encodeURIComponent(message);
  };

  const saveImage = async () => {
    const APIURL = `${API_URL}/user/properties/download/${property.id}`;
    const TOKEN = localStorage.getItem('token');

    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'download-image',
          url: APIURL,
          headers: { Authorization: `Bearer ${TOKEN}` },
          filename: `property-${property.id}.png`,
        })
      );
      return;
    }

    const response = await fetch(APIURL, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${TOKEN}`
      }
    })

    if (!response.ok || !response.headers.get('content-type')?.includes('image/png')) {
      const errorText = await response.text();
      console.error('Not a valid PNG:', errorText);
      alert('Failed to download image. Check console for error.');
      return;
    }
    
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'property-'+property.id+'.png';
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);
  }

  return(
    <MainLayout 
      isTopBar 
      screenTitle={ t('property.title') }
      headerLeft={
        Number(property?.user_id) === Number(JSON.parse(localStorage.getItem('user'))?.id) ?
          <MdDownloading size={22} className='cursor-pointer' color={PRIMARY} onClick={saveImage} />
        :
          property?.favorites?.length > 0 && property?.favorites.some(fav => fav.user_id === JSON.parse(localStorage.getItem('user'))?.id) ?
            <IoHeartSharp size={22} onClick={addToFavorites} className='cursor-pointer' color={PRIMARY} />
          :
            <IoHeartOutline size={22} onClick={addToFavorites} className='cursor-pointer' color={PRIMARY} />
      }
    >
      {propertyLoading ?
        <div className="loader-container mt-4">
          <div className="loader"></div>
        </div>
      :
        <Row className="justify-content-center mx-0">
          <Col md="8" className="px-0">
            <div className="bg-primary p-4 text-center">
              <h6 className='fw-bold mb-3 property-view-title text-white'>{ tField(property, 'title') }</h6>
              {property?.price &&
                <h6 className='fw-bold text-light property-view-price'>
                  { printPrice(property?.price) } د.ك
                </h6>
              }

              <Row className='mt-4'>
                <Col md="6" className='mx-auto d-flex align-items-center justify-content-center gap-3'>
                  <div className='property-view-info-container d-flex align-items-center'>
                    <FiClock color={PRIMARY} />
                    <span className='ms-2 small'>
                      {property?.created_at &&
                        moment(property.created_at)
                          .fromNow()
                          .replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d))
                      }
                    </span>
                  </div>
                  <div className='property-view-info-container d-flex align-items-center'>
                    <FaEye color={PRIMARY} />
                    <span className='ms-2 small'>
                      { property?.views }
                    </span>
                  </div>
                  <div className='property-view-info-container' onClick={share}>
                    <FiShare2 color={PRIMARY} />
                  </div>
                </Col>
              </Row>
            </div>

            <div className="p-4">
              <p className='text-center' dangerouslySetInnerHTML={{__html: nl2br(property?.description_ar)}} />

              <div className="text-center d-flex justify-content-center align-items-center mb-4">
                {property?.user?.is_office ?
                  <Link to={"/office/"+property?.user?.id} className='btn btn-sm bg-primary btn-icon text-white w-auto'>
                    <div className="property-office-image-container">
                      <img 
                        src={property?.user?.profile_picture_path ? STORAGE_URL + property?.user?.profile_picture_path : require('../../assets/images/default-office.png')} 
                        alt="Office" 
                        className='property-office-image rounded-circle me-1' 
                        width={30}
                        height={30}
                      />
                    </div>
                    <span className="small">
                      {getOfficeName(property?.user)?.substr(0, 20) || ''}
                      { getOfficeName(property?.user)?.length > 20 ? '...' : '' }
                    </span>

                    {property?.user?.is_verified ?
                      <RiVerifiedBadgeFill size={20} className='ms-1' />
                    :
                      null
                    }
                  </Link>
                :
                  ''
                }
              </div>

              <div className="px-lg-4 text-center mb-3">
                {property?.images?.length > 0 || property?.videos?.length > 0 ?
                  selectedImage?.includes('video') ?
                    <video
                      src={selectedImage}
                      width="60%"
                      height="auto"
                      controls
                      style={{cursor: 'pointer'}}
                    />
                  :
                    <img 
                      src={selectedImage} 
                      width={'80%'} 
                      className='rounded property-view-image-main' 
                      onClick={() => openImageViewer(selectedImage)}
                      style={{cursor: 'pointer'}}
                    />
                :
                  <img src={require('../../assets/images/default-office.png')} width={'80%'} alt="" className='rounded property-view-image-main' />
                }
              </div>

              <Row className='px-lg-4 justify-content-center d-flex align-items-center'>
                {property?.videos?.length > 0 && property?.videos?.map((data, key) => {
                  return(
                    <Col md="2" xs="4" key={key} className='mt-2'>
                      <video
                        src={STORAGE_URL + data.video_path}
                        width="100%"
                        height="80"
                        className={
                          "rounded" +
                          (selectedImage === STORAGE_URL + data.video_path
                            ? " border border-2 border-primary"
                            : "")
                        }
                        onClick={() => setSelectedImage(STORAGE_URL + data.video_path)}
                        style={{objectFit: 'cover', cursor: 'pointer'}}
                      />
                    </Col>
                  );
                })}

                {property?.images?.length > 0 && property?.images?.map((data, key) => {
                  return(
                    <Col md="2" xs="4" key={key} className='mt-2'>
                      <img 
                        src={STORAGE_URL+data.image_path} 
                        width={'100%'} 
                        height={'80px'} 
                        alt="" 
                        className={'rounded' + (selectedImage === STORAGE_URL+data.image_path ? ' border border-2 border-primary' : '')} 
                        onClick={() => setSelectedImage(STORAGE_URL+data.image_path)}
                        style={{objectFit: 'cover', cursor: 'pointer'}}
                      />
                    </Col>
                  );
                })}
              </Row>

              {Number(property?.user_id) === Number(JSON.parse(localStorage.getItem('user'))?.id) &&
                <Row className='mt-4 px-lg-4 justify-content-center'>
                  <Col md="4" xs="6" className='mb-2'>
                    <DefaultButton 
                      color={'primary'} 
                      block 
                      onClick={() => navigate('/my_properties/create', { state: { property } })}
                    >
                      تعديل
                    </DefaultButton>
                  </Col>
                  <Col md="4" xs="6" className='mb-2'>
                    {property?.status === 'archived' ?
                      <DefaultButton 
                        color={'success'} 
                        block 
                        outline 
                        loading={pauseLoading}
                        onClick={() => pause('activate')}
                        disabled={pauseLoading}
                      >
                        تشغيل الإعلان
                      </DefaultButton>
                    :
                      property?.status === 'paused' ?
                        <DefaultButton 
                          color={'success'} 
                          block 
                          outline 
                          loading={pauseLoading}
                          onClick={() => pause('activate')}
                          disabled={pauseLoading}
                        >
                          تشغيل الإعلان
                        </DefaultButton>
                      :
                        <DefaultButton 
                          color={'danger'} 
                          block 
                          outline 
                          loading={pauseLoading}
                          onClick={() => pause('pause')}
                          disabled={pauseLoading}
                        >
                          ايقاف مؤقت
                        </DefaultButton>
                    }
                  </Col>
                  <Col md="4" xs="6" className='mb-2'>
                    <DefaultButton color={'warning'} block onClick={() => setBoostModalShown(true)}>
                      تثبيت الإعلان
                    </DefaultButton>
                  </Col>
                  <Col md="4" xs="6" className='mb-2'>
                    <DefaultButton color={'danger'} block onClick={() => setDeleteModalShown(true)}>
                      حذف الاعلان
                    </DefaultButton>
                  </Col>
                </Row>
              }
            </div>

            <DeletePropertyModal 
              isOpen={deleteModalShown}
              toggle={() => setDeleteModalShown(!deleteModalShown)} 
              propertyId={property?.id}
              onSuccess={() => {
                navigate('/my_properties?p='+generateKey());
              }}
            />

            <BoostPropertyModal 
              isOpen={boostModalShown}
              toggle={() => setBoostModalShown(!boostModalShown)} 
              propertyId={property?.id}
              onSuccess={() => {
                navigate('/my_properties?p='+generateKey());
              }}
            />

            {/* Fixed CTA */}
            {property?.phone_number &&
              <div className="bottom-fixed-cta">
                <a 
                  href={`tel:${property?.user?.country_code}${property?.phone_number}`} 
                  className='btn btn-dark btn-lg'
                  onClick={incrementCallsCount}
                >
                  <FaPhoneAlt size={18} style={{marginTop: '-1px'}} />
                </a>
                <a 
                  href={`https://wa.me/${property?.user?.country_code}${property?.phone_number}?text=${generateWhatsappMessage()}`} 
                  target='_blank' 
                  className='btn btn-success btn-lg flex-grow-1 btn-property-whatsapp'
                  onClick={incrementWhatsappCount}
                >
                  <div style={{marginTop: '-1px'}}>
                    <IoLogoWhatsapp size={20} />{' '}
                    { t('property.whatsapp') }
                  </div>
                </a>
              </div>
            }
          </Col>
        </Row>
      }

      {/* Image Viewer Modal */}
      <Modal 
        isOpen={imageViewerOpen} 
        toggle={() => setImageViewerOpen(false)}
        size="lg"
        fullscreen
        centered
        className="image-viewer-modal"
      >
        <ModalBody className="p-0 position-relative" style={{backgroundColor: '#000'}}>
          <div 
            className="position-absolute top-0 end-0 m-3 cursor-pointer" 
            style={{zIndex: 1000}}
            onClick={() => setImageViewerOpen(false)}
          >
            <IoClose size={35} color="#fff" />
          </div>

          <div className="d-flex align-items-center justify-content-center" style={{minHeight: '100vh'}}>
            {allMedia[currentImageIndex]?.type === 'video' ? (
              <video
                src={allMedia[currentImageIndex]?.path}
                controls
                style={{maxWidth: '100%', maxHeight: '80vh'}}
                autoPlay
              />
            ) : (
              <img 
                src={allMedia[currentImageIndex]?.path}
                alt="Preview"
                style={{maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain'}}
              />
            )}
          </div>

          {allMedia.length > 1 && (
            <>
              <div 
                className="position-absolute top-50 end-0 translate-middle-y cursor-pointer p-3"
                onClick={prevImage}
                style={{zIndex: 1000}}
              >
                <IoChevronBack size={40} color="#fff" />
              </div>
              <div 
                className="position-absolute top-50 start-0 translate-middle-y cursor-pointer p-3"
                onClick={nextImage}
                style={{zIndex: 1000}}
              >
                <IoChevronForward size={40} color="#fff" />
              </div>
            </>
          )}

          <div className="position-absolute bottom-0 w-100 text-center text-white p-2" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
            {currentImageIndex + 1} / {allMedia.length}
          </div>
        </ModalBody>
      </Modal>
    </MainLayout>
  );
}

export default PropertyPage;